import Title from "./Sections/Title";
import Summary from "./Sections/Summary";
import Question from "./Sections/Question";
import Paragraph from "./Sections/Paragraph";
import Image from "./Sections/Image";
import Quote from "./Sections/Quote";

import { Grid } from "@mui/material";


const Section = (props) => {

  return (
    <Grid item xs={12} md={10} lg={8} sx={{ mt: "1.0rem"}}>
      { props.type === "title" && (
        <Title text={props.text} date={props.date}></Title>
      )}
      { props.type === "summary" && (
        <Summary text={props.text}></Summary>
      )}
      { props.type === "question" && (
        <Question text={props.text}></Question>
      )}
      { props.type === "paragraph" && (
        <Paragraph text={props.text}></Paragraph>
      )}
      { props.type === "image" && (
        <Image filename={props.text}></Image>
      )}
      { props.type === "quote" && (
        <Quote text={props.text}></Quote>
      )}
    </Grid>
  )
}

export default Section;